import React from 'react';
import { motion } from 'framer-motion';
import { PageHero } from '../../components/PageHero';
import { Clock, Coffee, ShieldCheck } from 'lucide-react';
export function GrabAndGoPage() {
  return <div className="bg-white" data-id="element-631">
      <PageHero title="Grab & Go" subtitle="Artisan quality meals and pastries crafted daily for those seeking excellence on the move." backgroundImage="https://images.unsplash.com/photo-1509440159596-0249088772ff?w=1920&q=80" data-id="element-632" />

      <section className="py-24 md:py-32" data-id="element-633">
        <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-634">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-32" data-id="element-635">
            {[{
            icon: <Clock size={40} data-id="element-636" />,
            title: 'Speed & Convenience',
            desc: 'Chef-prepared meals ready when you are, without compromising on quality.'
          }, {
            icon: <Coffee size={40} data-id="element-637" />,
            title: 'Artisan Coffee',
            desc: 'Locally roasted beans pulled by expert baristas to start your day right.'
          }, {
            icon: <ShieldCheck size={40} data-id="element-638" />,
            title: 'Uncompromising Quality',
            desc: 'The same premium ingredients used in our flagship restaurants, packaged to go.'
          }].map((feature, idx) => <motion.div key={idx} className="text-center p-8 bg-brand-gray/10 rounded-sm" initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: idx * 0.1
          }} data-id="element-639">
                <div className="text-brand-terracotta flex justify-center mb-6" data-id="element-640">
                  {feature.icon}
                </div>
                <h3 className="text-2xl font-serif text-brand-dark mb-4" data-id="element-641">
                  {feature.title}
                </h3>
                <p className="text-brand-dark/70 font-light" data-id="element-642">{feature.desc}</p>
              </motion.div>)}
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-643">
            <motion.div initial={{
            opacity: 0,
            x: -30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} data-id="element-644">
              <img src="https://images.unsplash.com/photo-1554118811-1e0d58224f24?w=800&q=80" alt="Cafe interior" className="w-full h-[600px] object-cover rounded-sm" data-id="element-645" />
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            x: 30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.2
          }} data-id="element-646">
              <h2 className="text-4xl md:text-5xl font-serif text-brand-dark mb-6" data-id="element-647">
                Our Locations
              </h2>
              <div className="w-16 h-1 bg-brand-gold mb-10" data-id="element-648"></div>

              <div className="space-y-8" data-id="element-649">
                {[{
                name: 'JJ Express - Financial District',
                address: '100 Wall Street, Lobby Level',
                hours: 'Mon-Fri: 6am - 5pm'
              }, {
                name: 'JJ Express - Tech Park',
                address: '400 Innovation Drive',
                hours: 'Mon-Fri: 7am - 6pm'
              }, {
                name: 'Nomad Kiosk',
                address: 'Central Station Main Concourse',
                hours: 'Daily: 5am - 9pm'
              }].map((loc, idx) => <div key={idx} className="border-b border-brand-dark/10 pb-6" data-id="element-650">
                    <h3 className="text-xl font-serif text-brand-dark mb-2" data-id="element-651">
                      {loc.name}
                    </h3>
                    <p className="text-brand-dark/60 font-light text-sm mb-1" data-id="element-652">
                      {loc.address}
                    </p>
                    <p className="text-brand-terracotta text-sm font-medium" data-id="element-653">
                      {loc.hours}
                    </p>
                  </div>)}
              </div>
            </motion.div>
          </div>
        </div>
      </section>
    </div>;
}